(function (app) {

    app.provider("questionApi",
    [
        function () {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};
                    
                    service.getQuestionCategories = function(transactionGroupId) {
                        return complianceHubApiGateway.getArray("/TransactionGroup/" + transactionGroupId + "/QuestionCategories");
                    }

                    service.createQuestionCategory = function(questionCategory) {
                        return complianceHubApiGateway.post("/QuestionCategories/", questionCategory);
                    }

                    service.createQuestion = function (question) {                     
                        return complianceHubApiGateway.post("/Questions/", question);
                    }

                    service.updateQuestionCategory = function (questionCategory) {
                        return complianceHubApiGateway.put("/QuestionCategories", questionCategory);
                    }

                    service.updateQuestion = function(question) {
                        return complianceHubApiGateway.put("/Questions/", question);
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line